import './style.scss';

const lpcbTouchStartHandler = (e) => {
    const popupInner = e.target.closest('.lpcb-pop-up__inner');
    if (popupInner) {
        const scrollTop = popupInner.scrollTop;
        const scrollHeight = popupInner.scrollHeight;
        const offsetHeight = popupInner.offsetHeight;

        if (scrollTop === 0) {
            popupInner.scrollTop = 1;
        } else if (scrollTop + offsetHeight >= scrollHeight) {
            popupInner.scrollTop = scrollHeight - offsetHeight - 1;
        }
    }
};

const lpcbTouchMoveHandler = (e) => {
    const popupInner = e.target.closest('.lpcb-pop-up__inner');
    if (!popupInner) {
        e.preventDefault(); // 背景は止める
    }
};
const lpcbIsIOSCheck = () => /iPhone|iPad|iPod/.test(navigator.userAgent);

const lpcbShowPopup = () => {
    const popup = document.getElementsByClassName('lpcb-pop-up');

    if(!popup || popup.length === 0) return;

    [...popup].forEach(elem => {

        const timing = elem.dataset.timing;

        const timingNum = parseInt(timing, 10);

        const timingMs = timingNum * 1000;

        setTimeout(() => {
            elem.classList.add('lpcb-pop-up--is-show');
            const shouldLock = elem.dataset.lockScroll === 'true';
            if (shouldLock) {
                const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
                document.body.style.overflow = 'hidden';
                document.body.style.paddingRight = `${scrollBarWidth}px`;
                const bg = elem.querySelector('.lpcb-pop-up__wrapper-background');
                if (bg && lpcbIsIOSCheck() ) {
                    bg.addEventListener('touchmove', lpcbTouchMoveHandler, { passive: false });
                    bg.addEventListener('touchstart', lpcbTouchStartHandler, { passive: false });
                    bg.dataset.touchMoveAttached = 'true'; // 識別用
                }
            }
        }, timingMs);
    })
}

const lpcbHidePopup = () => {
    const btn = document.querySelectorAll('.lpcb-pop-up__close-btn, .lpcb-pop-up__wrapper-background');

    if (!btn || btn.length === 0) return;

    [...btn].forEach(elem => {

        elem.addEventListener('click', () => {
            const popup = document.querySelector('.lpcb-pop-up');

            if (popup) {
                popup.classList.remove('lpcb-pop-up--is-show');
                const shouldLock = popup.dataset.lockScroll === 'true';
                if (shouldLock) {
                    document.body.style.overflow = '';
                    document.body.style.paddingRight = '';
                    const bg = popup.querySelector('.lpcb-pop-up__wrapper-background');
                    if (bg && bg.dataset.touchMoveAttached === 'true' && lpcbIsIOSCheck()) {
                        bg.removeEventListener('touchmove', lpcbTouchMoveHandler);
                        bg.removeEventListener('touchstart', lpcbTouchStartHandler);
                        delete bg.dataset.touchMoveAttached;
                    }
                }
            }
        })
        
    })
}
lpcbHidePopup();

const lpcbShowPopupScrollBlockPosition = () => {
    const trigger = document.getElementsByClassName('wp-block-lpc-blocks-pop-up');

    if (!trigger && trigger.length === 0) return;

    [...trigger].forEach(elem => {
        const observer = new IntersectionObserver((entries) => {
            for (const e of entries) {
                if (e.isIntersecting) {
                    // ウィンドウ内に入った時の処理
                    const popup = elem.querySelector('.lpcb-pop-up');

                    if (!popup.classList.contains('lpcb-pop-up--is-showed')) {
                        popup.classList.add('lpcb-pop-up--is-show');
                        popup.classList.add('lpcb-pop-up--is-showed');
                        const shouldLock = popup.dataset.lockScroll === 'true';
                        if (shouldLock) {
                            const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
                            document.body.style.overflow = 'hidden';
                            document.body.style.paddingRight = `${scrollBarWidth}px`;
                            const bg = elem.querySelector('.lpcb-pop-up__wrapper-background');
                            if (bg && lpcbIsIOSCheck()) {
                                bg.addEventListener('touchmove', lpcbTouchMoveHandler, { passive: false });
                                bg.addEventListener('touchstart', lpcbTouchStartHandler, { passive: false });
                                bg.dataset.touchMoveAttached = 'true'; // 識別用
                            }
                        }
                    }
                }
            }
        }, {});
        observer.observe(elem);
    })

    
}

const lpcbSetPopup = () => {
    const popup = document.getElementsByClassName('lpcb-pop-up');

    if(!popup || popup.length === 0) return;

    [...popup].forEach(elem => {
        const triggerType = elem.dataset.triggerType;

        if (!triggerType) return;

        switch (triggerType) {
            case 'timeout':
                lpcbShowPopup();
                break;

            case 'position':
                lpcbShowPopupScrollBlockPosition();
                break;
        }
    });

    
}
lpcbSetPopup();